/** @format */

export * from './lib/scorecard-plus-config.service';
